export function bobAIIcon({ onMouseEnter, onMouseLeave, style, title } = {}) {
  return (
    <img
      src="/assets/bobAI/bobAIlogo_2.png"
      alt="bobAI Icon"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      style={{ width: 20, height: 20, cursor: onMouseEnter ? 'pointer' : 'default', ...(style || {}) }}
    />
  );
}
